import { action } from '@ember/object';
import Component from '@glimmer/component';

import FormCheckboxSwitchComponent from 'webapp/components/form/checkbox-switch';

import type Block from 'webapp/models-custom/block';

interface Args {
	blockM: Block;
}

export default class BlockSettingsShowTotalsComponent extends Component<Args> {
	get block(): Block {
		return this.args.blockM;
	}

	get blockSetup() {
		return this.block.blockSetup;
	}

	get selected(): boolean {
		return this.block.showTotals;
	}

	@action
	changeSelected(selected: boolean): void {
		this.block.showTotals = selected;
		this.blockSetup.saveBlock();
	}

	<template>
		<div class="row row--toggle">
			<FormCheckboxSwitchComponent
				@name="showTotals"
				@selected={{this.selected}}
				@onChange={{this.changeSelected}}
			/>
			<label>Show total values for stacked</label>
		</div>
	</template>
}
